<template>
	<v-card>
		<v-card-title>
			<v-btn 
				icon color="primary"
				:loading="isloading"
				@click="getMensajes"
			>
				<v-icon>refresh</v-icon>
			</v-btn>
			<span>Mensajería</span>
		</v-card-title>
		<v-card-text>
			<v-data-table
				:headers="headers"
				:items="mensajes"
				:options.sync="pagination"
				:server-items-length="totalRecords"
				loading-text="Cargando..."
				no-data-text="No hay mensajes que mostrar..."
				show-expand single-expand dense
				item-key="hash"
				:expanded.sync="expanded"
				locale="es"
				sort-by="fecha"
				sort-desc
				@update:options="onload"
			>
			<template v-slot:item.leido="{value}">
					<v-icon :color="value?undefined:'primary'" 
						v-text="value?'drafts':'email'" />  
				</template>
				<template v-slot:item.fecha="{value}">
					<span>{{ formatDate(value) }}</span>
				</template>
				<template v-slot:expanded-item="{ headers, item }">
					<td :colspan="headers.length">
						<v-container fluid>
							<v-container fluid v-html="item.mensaje"/>
							<v-container fluid>
								<span>
									Fecha respuesta: 
									{{ formatDate((item.opciones.find(({fecha_respuesta})=>!!fecha_respuesta)||{}).fecha_respuesta) }}
								</span>
								<template v-for="(rows, n) in agruparOpciones(item)">
									<v-card-actions :key="`opc--`+n">
										<v-row>
											<v-col :key="n+'item'+c" v-for="(opcion, n) in rows">
												<v-btn
													v-if="opcion.opc_key === 'boton'"
													:key="`opc--`+n" color="primary" depressed
													:disabled="opcion.respuesta === null"
													:ripple="false"
												>
													{{ opcion.opc_value }}
												</v-btn>
												<v-textarea
													v-else-if="opcion.opc_key === 'texto'"
													:key="`opc-txt--${c}`"
													:label="opcion.opc_value" outlined
													readonly
													:value="opcion.respuesta"
												>

												</v-textarea>
											</v-col>
										</v-row>
									</v-card-actions>
								</template>
							</v-container>
						</v-container>
					</td>
				</template>
			</v-data-table>
		</v-card-text>
	</v-card>
</template>
<script>
import { apiGetMensajes } from '@/library/api/mensajeria';
import {format} from 'date-fns'

	export default {
		name: 'indexMensajeria'
		,props:{
			emisor:{required:true}
		}
		,computed:{
			mensajes(){	return this.lista	}
		}
		,data() {
			return {
				pagination:{},
				lista:[],
				headers:[
					{text: 'Leído',value: 'leido',}
					,	{text: 'Grupo',value: 'grupo_identificador',}
					, {text: 'Asunto',value: 'asunto',}
					, {text: 'Fecha',value: 'fecha',}
					, {value: 'data-table-expand' }
				],
				expanded:[],
				totalRecords: 0,
				isloading: false,
				sub: null
			}
		},
		methods:{
			formatDate(str){
				return format(new Date(str), 'dd/MM/yyyy HH:mm:ss')
			},
			onload(){
				if( !this.emisor )	return;
				this.getMensajes();
			}
			,async getMensajes(){

				try{

					this.isloading = true;

					const contribuyente = this.$store.getters['empresas/selectedRut'];
					const username = this.$store.getters['usuario/usuario'];
					const pag = JSON.parse(JSON.stringify(this.pagination));

					let {mensajes, total} = await apiGetMensajes(contribuyente, username, pag, {todos:true})
					this.lista = mensajes;
					this.totalRecords = parseInt(total);
					this.isloading = false;
				}catch(e){
					console.error(e)
				}finally{
					this.isloading = false;
				}
			}
			,agruparOpciones(mensaje){
				const rows = [];
				let opciones = mensaje.opciones;
				let col = [];
	
				for( let opcion of opciones.toSorted((a,b)=>(a.opc_order-b.opc_order) )){
					
					if( opcion.opc_key === 'boton' ){
						
						if( col.length === 0 ){
							col.push(opcion);
						}else if( opcion.opc_key === 'boton' && col[col.length-1].opc_key === 'boton' ){
							col.push(opcion);
						}else{
							// col.push(opcion);
							rows.push(col);
							col = [opcion]
						}
					}else{
						
						if(col.length)	rows.push(col);
						rows.push([opcion]);
						col = []
					}
				}
				if( col.length > 0 )	rows.push(col);
	
				return rows;
			},
		},
		mounted(){
			this.sub = this.$store.subscribe(({type}={})=>{
				if( type === 'empresas/select' ){
					this.onload();
				}
			});
		}
		,beforeDestroy(){
			if( !!this.sub )	this.sub();
		}
	}
</script>